var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { FormGroupLabel } from '../FormGroupLabel';
var InputFileVertical = /** @class */ (function (_super) {
    __extends(InputFileVertical, _super);
    function InputFileVertical() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputFileVertical.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, isRequired = _a.isRequired, accept = _a.accept, valid = _a.valid, invalid = _a.invalid, disabled = _a.disabled, feedback = _a.feedback, onChange = _a.onChange, className = _a.className, id = _a.id, multiple = _a.multiple, helpText = _a.helpText;
        var newId = id ? id : name + '_' + Math.random();
        return (React.createElement(FormGroupLabel, { isRounded: false, className: className, label: label, isRequired: isRequired, helpText: helpText, feedback: feedback, valid: valid, invalid: invalid },
            React.createElement("input", { id: newId, name: name, type: 'file', required: isRequired || false, accept: accept, disabled: disabled, multiple: multiple, className: 'outline-none', onChange: function (evt) {
                    if (multiple) {
                        onChange(evt.target.files);
                    }
                    else {
                        onChange(evt.target.files[0]);
                    }
                } })));
    };
    return InputFileVertical;
}(PureComponent));
export default InputFileVertical;
//# sourceMappingURL=InputFileVertical.js.map